<div class="audit-log-dialog">

<!--p>Audit log</p-->

<mat-tab-group (selectedTabChange)="onTabChanged($event)">
  <mat-tab>
    <ng-template mat-tab-label>Kreiranje</ng-template>
    <div class="table-wrapper">
      @if (!selectedItem) {
        <table class="table table-hover">
          <thead>
            <tr>
              <th>
                <p>Čas</p>
              </th>
              <th>
                <p>Uporabnik</p>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (read of inserts; track read.Id) {
              <tr (click)="setSelected(read)"
                class="clickable"
                title="Podrobno">
                <td>
                  <div>
                    <p>{{read.LogDateTime | date:'dd.MM.yyyy HH:mm:ss'}}</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>{{read.Username}}</p>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      @if (selectedItem) {
        <div class="selected-item-audit">
          <button type="button" (click)="clean()">Nazaj</button>
          <ngx-json-viewer [json]="differences"></ngx-json-viewer>
        </div>
      }

    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>Branje</ng-template>

    <div class="table-wrapper">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              <p>Čas</p>
            </th>
            <th>
              <p>Uporabnik</p>
            </th>
          </tr>
        </thead>

        <tbody>
          @for (read of paginatedReads; track read.Id) {
            <tr>
              <td>
                <div>
                  <p>{{read.LogDateTime | date:'dd.MM.yyyy HH:mm:ss'}}</p>
                </div>
              </td>
              <td>
                <div>
                  <p>{{read.Username}}</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (readsTotalPages > 1) {
        <div class="pagination-controls">
          <button (click)="goToReadsPage(readsCurrentPage - 1)"
          [disabled]="readsCurrentPage === 1">←</button>
          <span>Stran {{readsCurrentPage}} od {{readsTotalPages}} ({{reads.length}} zapisov)</span>
          <button (click)="goToReadsPage(readsCurrentPage + 1)"
          [disabled]="readsCurrentPage === readsTotalPages">→</button>
        </div>
      }
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>Pisanje</ng-template>
    <div class="table-wrapper">
      @if (!selectedItem) {
        <table class="table table-hover">
          <thead>
            <tr>
              <th>
                <p>Čas</p>
              </th>
              <th>
                <p>Uporabnik</p>
              </th>
              <th>
                <p>Spremembe</p>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (read of paginatedUpdates; track read.Id) {
              <tr (click)="setSelected(read)"
                class="clickable"
                title="Podrobno">
                <td>
                  <div>
                    <p>{{read.LogDateTime | date:'dd.MM.yyyy HH:mm:ss'}}</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>{{read.Username}}</p>
                  </div>
                </td>
                <td>
                  @if (getChangesData(read.LogData); as changes) {
                    @if (isString(changes)) {
                      <div>
                        <p class="changes-column">{{changes}}</p>
                      </div>
                    } @else {
                      @if (changes.count <= 2) {
                        <div>
                          <p class="changes-column">{{changes.paths.join(', ')}}</p>
                        </div>
                      } @else {
                        <div class="dropdown-container">
                          <button class="dropdown-toggle"
                            (click)="$event.stopPropagation(); toggleDropdown(read.Id)"
                            [class.open]="isDropdownOpen(read.Id)">
                            {{changes.count}} sprememb ▼
                          </button>
                          @if (isDropdownOpen(read.Id)) {
                            <div class="dropdown-menu"
                              (click)="$event.stopPropagation()">
                              @for (path of changes.paths; track path) {
                                <div class="dropdown-item">
                                  {{path}}
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      @if (updatesTotalPages > 1 && !selectedItem) {
        <div class="pagination-controls">
          <button (click)="goToUpdatesPage(updatesCurrentPage - 1)"
          [disabled]="updatesCurrentPage === 1">←</button>
          <span>Stran {{updatesCurrentPage}} od {{updatesTotalPages}} ({{filteredUpdatesCount}} zapisov)</span>
          <button (click)="goToUpdatesPage(updatesCurrentPage + 1)"
          [disabled]="updatesCurrentPage === updatesTotalPages">→</button>
        </div>
      }

      @if (selectedItem) {
        <div class="selected-item-audit">
          <button type="button" (click)="clean()">Nazaj</button>
          <ngx-json-viewer [json]="differences"></ngx-json-viewer>
        </div>
      }

    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>Posebne akcije</ng-template>
    <div class="table-wrapper">
      @if (!selectedItem) {
        <table class="table table-hover">
          <thead>
            <tr>
              <th>
                <p>Čas</p>
              </th>
              <th>
                <p>Uporabnik</p>
              </th>
              <th>
                <p>Opis</p>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (read of paginatedCustomActions; track read.Id) {
              <tr (click)="setSelected(read)"
                class="clickable"
                title="Podrobno">
                <td>
                  <div>
                    <p>{{read.LogDateTime | date:'dd.MM.yyyy HH:mm:ss'}}</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>{{read.Username}}</p>
                  </div>
                </td>
                <td>
                  <div>
                    <p>{{read.LogData}}</p>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

      @if (customActionsTotalPages > 1 && !selectedItem) {
        <div class="pagination-controls">
          <button (click)="goToCustomActionsPage(customActionsCurrentPage - 1)"
          [disabled]="customActionsCurrentPage === 1">←</button>
          <span>Stran {{customActionsCurrentPage}} od {{customActionsTotalPages}} ({{filteredCustomActionsCount}} zapisov)</span>
          <button (click)="goToCustomActionsPage(customActionsCurrentPage + 1)"
          [disabled]="customActionsCurrentPage === customActionsTotalPages">→</button>
        </div>
      }

      @if (selectedItem) {
        <div class="selected-item-audit">
          <button type="button" (click)="clean()">Nazaj</button>
          <ngx-json-viewer [json]="differences"></ngx-json-viewer>
        </div>
      }

    </div>
  </mat-tab>
</mat-tab-group>

</div>